import MButton from './Button.vue';

export default MButton;
